import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from '../../../../utilities/requestClient';
import { RiskComparisonTimeseries } from './risk-comparison.types';

export function useRiskComparisonTimeSeries(
  fundId: string,
  positionName: string | null,
  referenceDate: string | null,
  comparisonDate: string | null,
) {
  return useQuery({
    queryKey: [
      'comparison-timeseries',
      fundId,
      positionName,
      referenceDate,
      comparisonDate,
    ],
    queryFn: () =>
      fetchTimeSeriesData(
        fundId,
        positionName!,
        referenceDate!,
        comparisonDate!,
      ),
    enabled: !!comparisonDate && !!referenceDate && !!positionName,
    staleTime: 1000 * 60 * 5,
  });
}

async function fetchTimeSeriesData(
  fundId: string,
  positionName: string,
  referenceDate: string,
  comparisonDate: string,
) {
  const encodedPosition = encodeURIComponent(positionName);

  const url = `risk-comparison-range/${fundId}/${referenceDate}/${comparisonDate}/?position_name_long=${encodedPosition}`;
  const { data } = await AxiosInstance.get<RiskComparisonTimeseries>(url);
  return data;
}
